import { render, staticRenderFns } from "./AttendanceCounter.vue?vue&type=template&id=4b0ec66e&"
import script from "./AttendanceCounter.vue?vue&type=script&lang=js&"
export * from "./AttendanceCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports